import { useQuery } from "@tanstack/react-query"

import { getAgreementLinks, getPrivacyPolicyAgreementLinks } from "./api"
import { QUERY_KEYS } from "../../constants"
import { useUserQuery } from "../queries"

export const useAgreementLinksQuery = () => {
  const { user } = useUserQuery()
  return useQuery({
    queryKey: [QUERY_KEYS.AGREEMENT_LINKS],
    queryFn: getAgreementLinks,
    enabled: !!user,
  })
}

export const usePrivacyPolicyAgreementLinksQuery = () => {
  const { user } = useUserQuery()
  return useQuery({
    queryKey: [QUERY_KEYS.PRIVACY_POLICY_AGREEMENT_LINKS],
    queryFn: getPrivacyPolicyAgreementLinks,
    enabled: !!user,
  })
}
